import React, { useState, useEffect, useRef } from 'react';
import api from "../Api.js";
import img1 from "../assets/serivices/pest control.png";
import img2 from "../assets/serivices/electrician.png";
import img3 from "../assets/serivices/plumber.png";
import img4 from "../assets/serivices/hair.png";
import img5 from "../assets/serivices/massage.png";
import img6 from "../assets/serivices/electrician.png";
import img7 from "../assets/serivices/plumber.png";
import img8 from "../assets/serivices/carpenter.png";
import img9 from "../assets/serivices/mechanic.png";
import img10 from "../assets/serivices/delivery.png";
import './Services.css';
import { useLocation, useNavigate } from 'react-router-dom';

const fallbackImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10
];

const getRelatedId = (value) => (
  typeof value === 'string' ? value : value?._id
);

const PopularServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const [isMobileView, setIsMobileView] = useState(false);
  const sliderRef = useRef(null);
  const autoPlayRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [scopeSubChildIds, setScopeSubChildIds] = useState(null);
  const [scopeError, setScopeError] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = (searchParams.get('search') || '').trim().toLowerCase();
  const categoryId = searchParams.get('categoryId');
  const subCategoryId = searchParams.get('subCategoryId');
  const childCategoryId = searchParams.get('childCategoryId');
  const categoryScope = location.state?.categoryScope;
  const hasCategoryScope = Boolean(categoryId || subCategoryId || childCategoryId);
  const [isScopeLoading, setIsScopeLoading] = useState(hasCategoryScope);
  const filteredServices = services.filter((service) => {
    const serviceTitle = (service.availableserviceTitle || '').toLowerCase();
    const matchesSearch = !searchQuery || serviceTitle.includes(searchQuery);
    const matchesScope = !scopeSubChildIds || scopeSubChildIds.has(getRelatedId(service.subchildCategoryId));
    return matchesSearch && matchesScope;
  });

  useEffect(() => {
    fetchServices();
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let cancelled = false;

    const loadCategoryScope = async () => {
      if (!hasCategoryScope) {
        setScopeSubChildIds(null);
        setScopeError(null);
        setIsScopeLoading(false);
        return;
      }

      setIsScopeLoading(true);
      try {
        let { subCategories, childCategories, subChildCategories } = categoryScope || {};
        if (!Array.isArray(subCategories) || !Array.isArray(childCategories) || !Array.isArray(subChildCategories)) {
          const [subCategoriesResponse, childCategoriesResponse, subChildCategoriesResponse] = await Promise.all([
            api.get('/api/web/sub-categories'),
            api.get('/api/web/child-categories'),
            api.get('/api/web/sub-child-categories')
          ]);
          subCategories = subCategoriesResponse.data.data;
          childCategories = childCategoriesResponse.data.data;
          subChildCategories = subChildCategoriesResponse.data.data;
        }

        const matchedSubCategories = subCategories.filter((subCategory) => {
          if (subCategoryId) return getRelatedId(subCategory._id) === subCategoryId;
          return getRelatedId(subCategory.categoryId) === categoryId;
        });
        const matchedSubCategoryIds = new Set(matchedSubCategories.map((item) => item._id));
        const matchedChildCategories = childCategories.filter((childCategory) => (
          childCategoryId
            ? getRelatedId(childCategory._id) === childCategoryId
            : matchedSubCategoryIds.has(getRelatedId(childCategory.subCategoryId))
        ));
        const matchedChildCategoryIds = new Set(matchedChildCategories.map((item) => item._id));
        const matchedSubChildIds = subChildCategories
          .filter((subChild) => matchedChildCategoryIds.has(getRelatedId(subChild.childCategoryId)))
          .map((subChild) => subChild._id)
          .filter(Boolean);

        if (!cancelled) {
          setScopeSubChildIds(new Set(matchedSubChildIds));
          setScopeError(null);
          setIsScopeLoading(false);
        }
      } catch (err) {
        console.error('Error loading categories for service search:', err);
        if (!cancelled) {
          setScopeSubChildIds(new Set());
          setScopeError('Unable to search within this category. Please try again.');
          setIsScopeLoading(false);
        }
      }
    };

    loadCategoryScope();
    return () => {
      cancelled = true;
    };
  }, [categoryId, subCategoryId, childCategoryId, categoryScope, hasCategoryScope]);

  useEffect(() => {
    if (isAutoPlaying && !isHovered && !isMobileView && filteredServices.length > 0) {
      autoPlayRef.current = setInterval(() => {
        const maxIndex = Math.max(0, filteredServices.length - slidesToShow);
        setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
      }, 3000);
    }
    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [isAutoPlaying, isHovered, isMobileView, filteredServices.length, slidesToShow]);

  const handleResize = () => {
    const width = window.innerWidth;
    setIsMobileView(width <= 768);
    if (width < 480) {
      setSlidesToShow(1);
    } else if (width <= 768) {
      setSlidesToShow(1);
    } else if (width < 1024) {
      setSlidesToShow(3);
    } else if (width < 1280) {
      setSlidesToShow(4);
    } else {
      setSlidesToShow(4);
    }
  };

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/web/available-services');
      
      if (response.data.success) {
        const activeServices = response.data.data.services.filter(s => s.status === true);
        setServices(activeServices);
        setError(null);
      } else {
        setError('Failed to fetch services');
      }
    } catch (err) {
      console.error('Error fetching services:', err);
      setError('Failed to load services. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getFallbackImage = (index) => {
    return fallbackImages[index % fallbackImages.length];
  };

  const handlePrev = () => {
    if (isMobileView) {
      scrollToSlide(currentIndex === 0 ? filteredServices.length - 1 : currentIndex - 1);
      return;
    }
    const maxIndex = Math.max(0, filteredServices.length - slidesToShow);
    setCurrentIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
  };

  const handleNext = () => {
    if (isMobileView) {
      scrollToSlide(currentIndex >= filteredServices.length - 1 ? 0 : currentIndex + 1);
      return;
    }
    const maxIndex = Math.max(0, filteredServices.length - slidesToShow);
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const scrollToSlide = (index) => {
    const wrapper = sliderRef.current;
    const card = wrapper?.querySelectorAll('.ps-card')[index];
    if (!wrapper || !card) return;
    wrapper.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    setCurrentIndex(index);
  };

  const handleDotClick = (index) => {
    if (isMobileView) {
      scrollToSlide(index);
      return;
    }
    setCurrentIndex(index);
  };

  const getTotalDots = () => {
    return Math.max(1, filteredServices.length - slidesToShow + 1);
  };

  useEffect(() => {
    setCurrentIndex(0);
  }, [searchQuery, categoryId, subCategoryId, childCategoryId, services.length]);

  if (loading) {
    return (
      <section className="ps-services-section">
        <div className="ps-container">
          <div className="ps-header">
            <div className="ps-header-content">
              <span className="ps-badge">✦ Top Services</span>
              <h2 className="ps-title">Popular Services</h2>
              <p className="ps-subtitle">Loading services...</p>
            </div>
          </div>
          <div className="ps-slider-wrapper">
            <div className="ps-slider">
              {[1, 2, 3, 4].map((_, index) => (
                <div key={index} className="ps-card ps-card-loading">
                  <div className="ps-card-image-loading"></div>
                  <div className="ps-card-body">
                    <div className="ps-card-title-loading"></div>
                    <div className="ps-card-price-loading"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="ps-services-section">
        <div className="ps-container">
          <div className="ps-header">
            <h2 className="ps-title">Popular Services</h2>
            <p className="ps-error">{error}</p>
          </div>
        </div>
      </section>
    );
  }

  if (isScopeLoading) {
    return (
      <section className="ps-services-section">
        <div className="ps-container">
          <div className="ps-header">
            <h2 className="ps-title">Search Results</h2>
            <p className="ps-subtitle">Finding services in this category...</p>
          </div>
        </div>
      </section>
    );
  }

  if (scopeError) {
    return (
      <section className="ps-services-section">
        <div className="ps-container">
          <div className="ps-header">
            <h2 className="ps-title">Service Search</h2>
            <p className="ps-error">{scopeError}</p>
          </div>
        </div>
      </section>
    );
  }

  if (filteredServices.length === 0) {
    return (
      <section className="ps-services-section">
        <div className="ps-container">
          <div className="ps-header">
            <h2 className="ps-title">{searchQuery ? 'Search Results' : 'Popular Services'}</h2>
            <p className="ps-subtitle">
              {searchQuery ? `No services found for "${searchQuery}".` : 'No services available'}
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section 
      className="ps-services-section"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="ps-container">
        {/* Header */}
        <div className="ps-header">
          <div className="ps-header-content">
            <span className="ps-badge">✦ {searchQuery ? 'Matching Services' : 'Top Services'}</span>
            <h2 className="ps-title">{searchQuery ? 'Search Results' : 'Popular Services'}</h2>
            <p className="ps-subtitle">
              {searchQuery ? `Services matching "${searchQuery}"` : 'Find the right professional for any job'}
            </p>
          </div>
          <div className="ps-nav-buttons">
            <button 
              className="ps-nav-btn ps-nav-prev" 
              onClick={handlePrev}
              aria-label="Previous"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button 
              className="ps-nav-btn ps-nav-next" 
              onClick={handleNext}
              aria-label="Next"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>

        {/* Slider */}
        <div
          className="ps-slider-wrapper"
          ref={sliderRef}
          onScroll={() => {
            if (!isMobileView || !sliderRef.current) return;
            const cards = sliderRef.current.querySelectorAll('.ps-card');
            const firstCard = cards[0];
            if (!firstCard) return;
            const gap = parseFloat(window.getComputedStyle(firstCard.parentElement).gap) || 0;
            const index = Math.round(sliderRef.current.scrollLeft / (firstCard.offsetWidth + gap));
            setCurrentIndex(Math.min(index, getTotalDots() - 1));
          }}
        >
          <div 
            className="ps-slider"
            style={{
              transform: isMobileView ? 'none' : `translateX(-${currentIndex * (100 / slidesToShow)}%)`,
              transition: 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)'
            }}
          >
            {filteredServices.map((service, index) => (
              <div
                key={service._id}
                className="ps-card"
                onClick={() => navigate(`/services/${service._id}`)}
                style={{
                  animationDelay: `${index * 0.1}s`,
                  flex: isMobileView ? '0 0 84%' : `0 0 ${100 / slidesToShow}%`
                }}
              >
                <div className="ps-card-image-wrapper">
                  <img
                    src={service.availableserviceLogo || getFallbackImage(index)}
                    alt={service.availableserviceTitle}
                    className="ps-card-image"
                    onError={(e) => {
                      e.target.src = getFallbackImage(index);
                    }}
                  />
                  <div className="ps-card-overlay">
                    <span className="ps-card-book-btn">Book Now →</span>
                  </div>
                </div>
                <div className="ps-card-body">
                  <h3 className="ps-card-title">{service.availableserviceTitle}</h3>
                  <div className="ps-card-meta">
                    {service.availablestartPrice && (
                      <span className="ps-card-price">
                        From <strong>${service.availablestartPrice}</strong>
                      </span>
                    )}
                    {service.availableserviceDuration && (
                      <span className="ps-card-duration">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12,6 12,12 16,14" />
                        </svg>
                        {service.availableserviceDuration}
                      </span>
                    )}
                  </div>
                  <div className="ps-card-rating">
                    <span className="ps-stars">★★★★★</span>
                    <span className="ps-rating-count">(4.9)</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots */}
        {getTotalDots() > 1 && (
          <div className="ps-dots">
            {Array.from({ length: getTotalDots() }).map((_, index) => (
              <button
                key={index}
                className={`ps-dot ${index === currentIndex ? 'ps-dot-active' : ''}`}
                onClick={() => handleDotClick(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Auto-play toggle */}
        <button 
          className="ps-autoplay-toggle"
          onClick={() => setIsAutoPlaying(!isAutoPlaying)}
          aria-label={isAutoPlaying ? 'Pause auto-play' : 'Resume auto-play'}
        >
          {isAutoPlaying ? '⏸' : '▶'}
        </button>
      </div>
    </section>
  );
};

export default PopularServices;